import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { Observable, of } from "rxjs";

@Injectable()
export class DmsSharedAuth implements CanActivate {
    constructor(private router: Router, private http: HttpClient) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.isAllowedAccess(route);
    }

    private isAllowedAccess(
        route: ActivatedRouteSnapshot
    ): Observable<boolean> {
        let returnVal = of(false);
        returnVal = Observable.create((observer) => {
            this.http
                .get(
                    "api/DmsSharedAuthorization/" +
                        route.params.projectId +
                        "/" +
                        route.queryParams.folder,
                    { responseType: "text" }
                )
                .subscribe(
                    (data) => {
                        const allowed = data == "true";

                        observer.next(allowed);
                        observer.complete();

                        if (!allowed)
                            this.router.navigateByUrl("/unauthorized");
                    },
                    () => {
                        observer.next(false);
                        observer.complete();

                        this.router.navigateByUrl("/unauthorized");
                    }
                );
        });

        return returnVal;
    }
}
